import React from 'react';
import AdminLayout from '../../components/Layout/AdminLayout';
export const AdminUsers: React.FC = () => {
  return (
    <AdminLayout title="Users">
      Users management view
    </AdminLayout>
  );
};

